import api from '@/api/api';
import router from '@/router';
import UploadFile from '@/shared/services/oss.service';
import { Component, Vue } from 'vue-property-decorator';


@Component({

})
export default class ConfirmPcAccept extends Vue {
  data: any = {};
  // 上传附件的值
  fileValues: any = {};
  // 入职模板
  dataTemplate: any = {
    entryDate: false,
    medicalInfo: false,
    registry: false,
    computerUse: false,
    physicalExamination: false,
    salaryTurnover: false,
    criminalCertificate: false
  };

  get showUploadGroup() {
    return this.dataTemplate['registry'] || this.dataTemplate['physicalExamination'] || this.dataTemplate['salaryTurnover'] || this.dataTemplate['criminalCertificate'];
  }

  offerId: any;
  offerData: any = {};
  submitting: boolean = false;

  mounted() {
    if (this.$route.query && this.$route.query.offerId) {
      this.offerId = this.$route.query.offerId;
      // OF9999999958
      api.getOfferInfoById(this.offerId).then(
        (res: any) => {
          console.log(res);
          this.offerData = res.offerData
        }
      )
    }
    api.getConfirmJsonByOfferId(this.offerId).then(
      (res: any) => {
        console.log(res.json);
        const templates = JSON.parse(res.json);
        const parseTemplate: any = {};
        for (let template of templates) {
          if (template.checked) {
            parseTemplate[template.LabelName] = true;
          }
        }
        this.dataTemplate = parseTemplate;
      }
    )
  }

  submit() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    const entity: any = {
      offerId: this.offerId,
      entryDate: this.data['entryDate'],
      computerUseChoise: this.data['computerUse'],
      physicalExamination: {
        name: this.data.name,
        phoneNumber: this.data.phoneNumber,
        birthYear: this.data.birthYear,
        age: this.data.age
      },
      offerReplyFiles: this.getFiles(),
      isAccept: true,
      refuseReason: ''
    }
    console.log(entity);
    api.confirmOffer(entity).finally(
      () => {
        this.submitting = false;
      }
    ).then(
      res => {
        router.push(`/submit-success?type=1`);
      }
    )
  }

  getFiles() {
    const fileTypes: any = {
      registry: '1',
      physicalExamination: '2',
      salaryTurnover: '3',
      criminalCertificate: '4'
    }
    const fileList = [];
    for (let key of Object.keys(fileTypes)) {
      const files = this.fileValues[key] || [];
      if (files.length === 1) {
        fileList.push({
          fileURL: files[0].url,
          fileClassFily: fileTypes[key]
        })
      }
    }
    return fileList;
  }

  beforeFileUpload(file: any, data: any) {
    UploadFile.addFileAliyun(file.file).then(
      (res: any) => {
        this.fileValues[file.data.name] = [{
          url: res.url
        }];
      }
    )
    return false;
  }

  onExceed() {
    this.$message({
      message: '只能上传一份附件',
      type: 'warning'
    });
  }
}